import React, { SVGProps } from 'react'

/**
 * Feature-local "report fraud" glyph for the ••• actions menu (matches the
 * design prototype). Lives here rather than in src/components/Svgs, which
 * `gen-svg-components` wipes and regenerates from src/assets/svgs — this has no
 * source asset.
 */
const SvgReportFraud = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M10 6.5v4M10 13.5v.1M2.6 15.5 10 3l7.4 12.5H2.6Z"
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgReportFraud
